import { render } from "./AppBarTitle.vue?vue&type=template&id=206e6958"
import script from "./AppBarTitle.vue?vue&type=script&lang=js"
export * from "./AppBarTitle.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__